import CircularProgress, {
  CircularProgressProps,
} from "@mui/material/CircularProgress";

export type { CircularProgressProps };
export default CircularProgress;
